import { IProdutoIncorporacaoForm } from '../../../../../../modules/types/ProdutoDaf';

export const defaultProdutoIncorporacaoFormMain: IProdutoIncorporacaoForm = {
  ////////////////////////////////////////
  // Identificador
  id: 0,

  ////////////////////////////////////////
  // Chaves estrangeiras
  produtoDAFId: 0,
  obmVmpId: 0,
  medsusDiretrizId: 0,

  ////////////////////////////////////////
  // Status e classificação
  statusIncorporacao: 0,
  statusPactuacao: 0,
  componentePactuado: 0,
  componenteGrupoFinanciamento: 0,

  ////////////////////////////////////////
  // Documento Técnico Orientador
  documentoTecnicoOrientador: 0,
  documentoTecnicoOrientadorTitulo: '',
  dataDocumento: '',
  documentoTecnicoOrientadorLink: '',

  ////////////////////////////////////////
  // Relatório de Recomendação
  dataRelatorioRecomendacao: '',
  relatorioRecomendacao: '',
  linkRelatorioRecomendacao: '',

  ////////////////////////////////////////
  // Incorporação
  dataIncorporacao: '',
  portariaIncorporacao: '',
  linkPortariaIncorporacao: '',

  ////////////////////////////////////////
  // Desincorporação
  dataDesincorporacao: '',
  portariaDesincorporacao: '',
  linkPortariaDesincorporacao: '',

  ////////////////////////////////////////
  // Pactuação
  dataPactuacao: '',
  ataPactuacao: '',
  ataPactuacaoLink: '',

  ////////////////////////////////////////
  // Atualização
  statusAtualizacao: 0,
  dataInicioAtualizacao: '',
  dataAtualizacao: '',
  motivoAtualizacao: '',
  motivoExclusao: '',

  ////////////////////////////////////////
  // Observações
  observacoes: '',
};
